export const formatNumberOnBlur = (inputValue: string, decimalPlaces = 2): string => {
  const result = parseFloat(inputValue) || 0;

  return result.toFixed(decimalPlaces).toString();
};
